import * as React from 'react';
import './AddSubscription.css';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import {
  Box,
  FormControlLabel,
  Switch,
  TextField,
  Typography,
} from '@material-ui/core';

function AddSubscriptionDialog(props: any) {
  const [loading, setLoading] = React.useState(false);
  const [state, setState] = React.useState({
    isActive: true,
    numOfTickets: 5,
    extra: 40,
    totalCost: 1000,
    isBonusActive: false,
    bonusPeriod: 0,
    bonusTickets: 0,
  });
  const [open, setOpen] = React.useState(false);
  const [scroll, setScroll] = React.useState('paper');

  const handleClickOpen = (scrollType) => () => {
    setOpen(true);
    setScroll(scrollType);
  };

  const handleClose = () => {
    setOpen(false);
    setState({
      isActive: true,
      numOfTickets: 5,
      extra: 40,
      totalCost: 1000,
      isBonusActive: false,
      bonusPeriod: 0,
      bonusTickets: 0,
    });
  };

  const handleChangeStatus = (e: any) => {
    setState({ ...state, isActive: e.target.checked });
  };
  const handleChangeBonusStatus = (e: any) => {
    setState({ ...state, isBonusActive: e.target.checked });
  };

  const handleChange = (e: any) => {
    setState({
      ...state,
      [e.target.name]: Number(e.target.value),
    });
  };

  const handleSubmit = async () => {
    setLoading(true);
    const res = await props.addSubscription({ subscriptionModel: state });
    setLoading(false);
    setOpen(false);
  };

  return (
    <Box>
      <Box
        display={'flex'}
        justifyContent={'space-between'}
        alignItems={'center'}
        mb={'20px'}
      >
        <Typography className='base-color'>Subscription Settings</Typography>
        <Button
          size='medium'
          variant='contained'
          color='primary'
          onClick={handleClickOpen('body')}
        >
          Add new
        </Button>
      </Box>
      <Dialog
        open={open}
        // onClose={handleClose}
        scroll={'body'}
        disableEscapeKeyDown
        aria-labelledby='scroll-dialog-title'
        aria-describedby='scroll-dialog-description'
      >
        <DialogTitle id='scroll-dialog-title'>Add new subscription</DialogTitle>
        <DialogContent>
          <Box display={'flex'} flexDirection={'column'}>
            <FormControlLabel
              control={
                <Switch
                  checked={state.isActive}
                  onChange={handleChangeStatus}
                />
              }
              label={state.isActive ? 'Active' : 'Disabled'}
            />
            <Box className='add-field-input'>
              <TextField
                size='small'
                required
                label='Monthly Cost'
                name='totalCost'
                type='number'
                variant='outlined'
                onChange={handleChange}
                value={state.totalCost}
              />
            </Box>
            <Box className='add-field-input'>
              <TextField
                className='add-field-input'
                size='small'
                required
                label='Num Of Tickets'
                name='numOfTickets'
                type='number'
                variant='outlined'
                onChange={handleChange}
                value={state.numOfTickets}
              />
            </Box>
            <Box className='add-field-input'>
              <TextField
                className='add-field-input last'
                size='small'
                required
                label='Extra'
                name='extra'
                type='number'
                variant='outlined'
                onChange={handleChange}
                value={state.extra}
              />
            </Box>
            <FormControlLabel
              control={
                <Switch
                  checked={state.isBonusActive}
                  onChange={handleChangeBonusStatus}
                />
              }
              label={state.isBonusActive ? 'Bonus Active' : 'Bonus Disabled'}
            />
            <Box className='add-field-input'>
              <TextField
                className='add-field-input'
                size='small'
                required
                label='Bonus Period(month)'
                name='bonusPeriod'
                type='number'
                variant='outlined'
                onChange={handleChange}
                value={state.bonusPeriod}
              />
            </Box>
            <Box className='add-field-input'>
              <TextField
                className='add-field-input last'
                size='small'
                required
                label='Bonus Tickets'
                name='bonusTickets'
                type='number'
                variant='outlined'
                onChange={handleChange}
                value={state.bonusTickets}
              />
            </Box>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button
            size='medium'
            variant='contained'
            color='primary'
            onClick={handleSubmit}
          >
            Add
          </Button>
          <Button
            size='medium'
            variant='contained'
            color='primary'
            onClick={handleClose}
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}

export default AddSubscriptionDialog;
